<app-complex-modal-template
    [isConfirmationMode]="false"
    [title]="'basemapManagement' | transloco"
    [titleSize]="'text-lg'"
    (onClickEvent)="closeModal($event)">
    <div
        #modalRoot
        class="ml-auto relative z-20 w-fit min-w-[20vw] pt-2">
        @if (picker()) {
            <app-basemap-management-modal-picker
                [allBasemapTypes]="ALL_BASEMAP_TYPES"
                [catalog]="catalog"
                [picker]="picker()"
                [pickerLeft]="pickerLeft()"
                [primaryBasemap]="primaryBasemap()"
                [secondariesBasemap]="secondariesBasemap()"
                (selectedPick)="pickBasemapType($event)" />
        }

        <div class="flex flex-col">
            <div class="flex flex-row px-6 gap-2">
                <app-toggle
                    [checked]="basemapService.isTerrainElevationActive"
                    (toggled)="toggleTerrainElevation($event)" />
                <span>{{ 'showTerrainElevation' | transloco }}</span>
            </div>
            <div class="flex flex-row pt-4">
                <section class="flex-2 flex-col gap-3 px-3">
                    <div class="inline-flex flex-col items-center gap-2 w-28">
                        <span class="text-lg font-semibold pr-1">{{ 'primary' | transloco }}</span>
                        <app-basemap-tile
                            [opacity]="1"
                            [opacityReadOnly]="true"
                            [selected]="isPrimaryOpen()"
                            [showHoverUpdate]="isPrimaryOpen()"
                            [type]="primaryBasemap()"
                            (pressed)="togglePicker({ mode: PickerMode.PRIMARY })" />
                    </div>
                </section>

                <section class="flex-1 flex-col gap-3 px-3">
                    <span class="text-lg font-semibold">{{ 'secondary' | transloco }}</span>

                    <div class="flex flex-wrap pt-2">
                        @for (basemapSecondary of secondariesBasemap(); track basemapSecondary.type) {
                            <app-basemap-tile
                                [opacity]="basemapSecondary.opacity"
                                [selected]="replacingSecondary() === basemapSecondary.type"
                                [showHoverUpdate]="isSecondaryOpen()"
                                [showTrash]="true"
                                [type]="basemapSecondary.type"
                                (opacityChange)="basemapService.setSecondaryOpacity(basemapSecondary.type, $event)"
                                (pressed)="
                                    togglePicker({
                                        mode: PickerMode.SECONDARY_REPLACE,
                                        secondaryTypeToReplace: basemapSecondary.type,
                                    })
                                "
                                (trash)="removeSecondary(basemapSecondary.type)" />
                        }
                        @if (showAddButton()) {
                            <div class="inline-flex flex-col items-center gap-2 w-28">
                                <button
                                    class="button-basemap border-2 border-transparent footer-shadow bg-transparent hover:border-custom-blue group"
                                    type="button"
                                    [class.border-custom-blue]="picker()?.mode === PickerMode.SECONDARY_ADD"
                                    (click)="openPickerAddSecondary()">
                                    <div
                                        class="w-full h-full flex flex-col items-center justify-center bg-white group-hover:bg-custom-light-blue transition-colors">
                                        <span
                                            class="font-normal text-custom-blue group-hover:text-custom-blue leading-none">
                                            <fa-icon
                                                size="2xl"
                                                [icon]="['fas', 'plus']" />
                                        </span>
                                        <span class="text-sm font-normal mt-1 text-custom-blue">
                                            {{ 'add' | transloco }}
                                        </span>
                                    </div>
                                </button>
                            </div>
                        }
                    </div>
                </section>
            </div>
        </div>
    </div>
</app-complex-modal-template>
